export const FETCH_CLOUDFRONT_REQUEST = 'FETCH_CLOUDFRONT_REQUEST'
export const FETCH_CLOUDFRONT_SUCCESS = 'FETCH_CLOUDFRONT_SUCCESS'
export const FETCH_CLOUDFRONT_FAILED = 'FETCH_CLOUDFRONT_FAILED'
